import { Base } from "./Base";
import { CantRemoveLastTeamUser, SpaceNotFoundException, throwExpected, UserNameNotFoundException, } from "./exceptions";
export const teamEntityKinds = ["Admin", "Normal", "Owner"];
/**
 *
 * The class for consuming all `team` resources.
 *
 * @remarks
 * This class should be generated using OpenAPI generator in the future.
 *
 * @alpha
 */
class TeamService extends Base {
    /**
     * Get one team by team id
     */
    async getOne({ id }) {
        const { apiEndpointAddress, fetch } = this.lensPlatformClient;
        const url = `${apiEndpointAddress}/teams/${id}`;
        const json = await fetch.get(url);
        return json;
    }
    /**
     * Get all teams
     */
    async getMany() {
        const { apiEndpointAddress, fetch } = this.lensPlatformClient;
        const url = `${apiEndpointAddress}/teams`;
        const json = await fetch.get(url);
        return json;
    }
    /**
     * Create one team
     */
    async createOne({ team }) {
        const { apiEndpointAddress, fetch } = this.lensPlatformClient;
        const url = `${apiEndpointAddress}/teams`;
        const json = await fetch.post(url, team);
        return json;
    }
    /**
     * Delete one team by team id
     */
    async deleteOne({ id }) {
        const { apiEndpointAddress, fetch } = this.lensPlatformClient;
        const url = `${apiEndpointAddress}/teams/${id}`;
        await fetch.delete(url);
    }
    /**
     * Add a user by username to a team by team id
     */
    async addUser({ username, id }) {
        const { apiEndpointAddress, fetch } = this.lensPlatformClient;
        const url = `${apiEndpointAddress}/teams/${id}/users`;
        const json = await fetch.post(url, { username });
        return json;
    }
    /**
     * Remove a user by username from a team by team id
     */
    async removeUser({ username, id }) {
        const { apiEndpointAddress, fetch } = this.lensPlatformClient;
        const url = `${apiEndpointAddress}/teams/${id}/users/${username}`;
        const json = await throwExpected(async () => fetch.delete(url), {
            404(error) {
                const message = error === null || error === void 0 ? void 0 : error.body.message;
                if (typeof message === "string" && message.includes("Space not found")) {
                    return new SpaceNotFoundException();
                }
                return new UserNameNotFoundException(username);
            },
            422: () => new CantRemoveLastTeamUser(),
        });
        return json;
    }
}
export { TeamService };
